import { Grid } from "@chakra-ui/react";
import { useController } from "react-hook-form";
import { StyledRadio, StyledRadioGroup } from "./radioBox.style";
import { RadioBoxProps } from "./radioBox.type";

export const RadioBox = ({ control, name, option }: RadioBoxProps) => {
    const { field } = useController({ name, control });
    return (
        <StyledRadioGroup {...field}>
            <Grid templateColumns="repeat(3, 1fr)" gap={"8px"}>
                {option.map((it) => (
                    <StyledRadio value={it.name} key={it.idx}>
                        {it.label}
                    </StyledRadio>
                ))}
            </Grid>
        </StyledRadioGroup>
    );
};
